module.exports = __webpack_public_path__ + "static/media/da-ct-scan-5.b309fb10.jpg";